import {
  ConsoleTransport,
  FetchTransport,
  getWebInstrumentations,
  initializeFaro,
  Transport
} from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { name, version } from '@/../package.json'

const getFeroTransports = () => {
  let transports: Transport[] = []
  const apiUrl = import.meta.env.VITE_GRAFANA_FARO_API_URL
  if (typeof apiUrl !== 'undefined') {
    transports.push(
      new FetchTransport({
        url: apiUrl,
        apiKey: import.meta.env.VITE_GRAFANA_FARO_API_KEY
      })
    )
  }

  if (import.meta.env.DEV) {
    transports.push(new ConsoleTransport())
  }

  return transports
}

const faroInstance = initializeFaro({
  instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
  transports: getFeroTransports(),
  app: {
    name,
    version
  }
})

export const useGrafanaFaro = () => ({ faroInstance })
